import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";
import {getRegionName} from "@/utils/functionsRegion";
import moment from "moment";
import {serializer} from "@/api/shared/serializer";
import { UserTypeEnum } from '@/enums/UserTypeEnum';
import { AuditLogsTier1 as Tier1, AuditLogsTier2 as Tier2, AuditLogsTier3 as Tier3 } from '@/enums/AuditLogs';

const digitalSignageModule: Module<any, any> = {
  namespaced: false,
  state: {
    currentDigitalSignage: null,
    currentDigitalSignageList: [],
    subscribeCurrentDigitalSignage: null,
    digitalSignageChanges: 0,
    digitalSignageDevices: [],
    digitalSignageTVList: [],
    digitalSignageTV: null,
    subscribeOnDigitalSignageTV: null,
    subscribeOnDigitalSignageActivePage: null,
    digitalSignageActivePage: null
  },

  mutations: {
    setcurrentDigitalSignage(state: any, payload: []) {
      state.currentDigitalSignage = payload;
    },
    setcurrentDigitalSignageList(state: any, payload: []) {
      state.currentDigitalSignageList = payload;
    },
    setDigitalSignageChanges(state: any) {
      state.digitalSignageChanges = state.digitalSignageChanges + 1;
    },
    setDigitalSignageDevices(state: any, payload: []) {
      state.digitalSignageDevices = payload;
    },
    setDigitalSignageTV(state: any, payload: {}) {
      state.digitalSignageTV = payload;
    },
    setDigitalSignageTVList(state: any, payload: []) {
      state.digitalSignageTVList = payload;
    },
    setDigitalSignageActivePage(state: any, payload: any) {
      state.digitalSignageActivePage = payload;
    }
  },

  actions: {
    async getDigitalSignages({ commit }) {
      const facilityId = this.state.authModule.currentFacility;

      const digitalSignage = firebase
        .firestore()
        .collection("digitalSignage")
        .where("facilityId", "==", facilityId);

      await digitalSignage.get().then((querySnapshot) => {
        const digSiganges: Array<any> = [];

        querySnapshot.docs.forEach((x) => {
          const ds = x.data();
          ds.id = x.id;
          ds.isResidentChannel = ds.isResidentChannel || false
          ds.isFamilyChannel = ds.isFamilyChannel || false
          ds.pages = ds.pages || []
          ds.isShowSidebar = ds.isShowSidebar || false
          digSiganges.push(ds);
        });
       
        commit("setcurrentDigitalSignageList", digSiganges);
      });
    },
    async getDigitalSignage({ commit }, dsId) {
      const digitalSignage = firebase
        .firestore()
        .collection("digitalSignage").doc(dsId)
      let o = 1;
      await digitalSignage.get()
        .then((querySnapshot) => {
          const digitalSignage = querySnapshot?.data();
          digitalSignage.id = querySnapshot?.id;
          digitalSignage.pages = digitalSignage.pages || []
          digitalSignage.isResidentChannel = digitalSignage.isResidentChannel || false
          digitalSignage.isFamilyChannel = digitalSignage.isFamilyChannel || false
          digitalSignage.isShowSidebar = digitalSignage.isShowSidebar || false
          digitalSignage.pages?.forEach(page => {
            page.order = o;
            o++;
          });

          const formatTime = (time, defaultTime) => {
            const timeFormat = time.includes("AM") || time.includes("PM") ? "hh:mm A" : "HH:mm";
            return moment(time || defaultTime, timeFormat).format(this.state.facilityModule.selectedFacility.timeFormat);
          };

          digitalSignage.pages?.forEach(page => {
            if (page?.time && page?.time?.start && page?.time?.end) {
              page.time.start = formatTime(page.time.start, "09:00");
              page.time.end = formatTime(page.time.end, "17:00");
            } else {
              page.time.start = formatTime("09:00", "09:00");
              page.time.end = formatTime("17:00", "17:00");
            }
          });

          commit("setcurrentDigitalSignage", digitalSignage);
        });
    },
    async createDigitalSignage({ dispatch }, newDs) {
      newDs.facilityId = this.state.authModule.currentFacility;
      newDs.pages = newDs.pages || []
      newDs.isResidentChannel = newDs.isResidentChannel || false
      newDs.isFamilyChannel = newDs.isFamilyChannel || false
      newDs.createdById = this.state.authModule.user.id;
      newDs.createdByType = UserTypeEnum.Staff;
      newDs.typesOfRecordChanged = [`${Tier1.DigitalSignage}: ${Tier2.DigitalSignage}: ${Tier3.Add}`];

      firebase
        .firestore()
        .collection("digitalSignage")
        .add(newDs)
        .then((querySnapshot) => {
          dispatch("getDigitalSignage", querySnapshot.id);
          router.push("/digital-signage/" + querySnapshot.id)
        });
    },
    async saveDigitalSignage({ dispatch }, digitalSignage) {
      digitalSignage.updatedById = this.state.authModule.user.id;
      digitalSignage.updatedByType = UserTypeEnum.Staff;
      digitalSignage.typesOfRecordChanged = [`${Tier1.DigitalSignage}: ${Tier2.DigitalSignage}: ${Tier3.Amend}`];

      await firebase
        .firestore()
        .collection("digitalSignage")
        .doc(digitalSignage.id)
        .update(digitalSignage)
        .then((querySnap: any) => {
          dispatch("getDigitalSignage", digitalSignage.id);
        });
    },
    removePageFromCurrentDigitalSignage({ dispatch }, pageToRemove) {
      const currentDigitalSignage = this.state.digitalSignageModule
        .currentDigitalSignage;
      currentDigitalSignage.pages.splice(pageToRemove, 1);
      dispatch("saveDigitalSignage", currentDigitalSignage);
    },
    async deleteDigitalSignage({ dispatch, state }, id) {
      await dispatch("removeFacilityIdFromPublishTo");
      const digitalSignageRef = await firebase.firestore().collection("digitalSignage").doc(id).get();

      await digitalSignageRef.ref.update({
        deletedById: this.state.authModule.user.id,
        deletedByType: UserTypeEnum.Staff,
        typesOfRecordChanged: [`${Tier1.DigitalSignage}: ${Tier2.DigitalSignage}: ${Tier3.Remove}`]
      });

      await digitalSignageRef.ref.delete().then(() => {
        dispatch("getDigitalSignages");
        router.push("/digital-signage")
      });
    },
    async removeFacilityIdFromPublishTo({ state }) {
      const digitalSignage = state.currentDigitalSignage;

      if(digitalSignage?.publishTo && digitalSignage?.publishTo.length && digitalSignage?.parentDigitalSignageId) {

        for(let i = 0; i < digitalSignage?.publishTo.length; i++) {

          const facilityId = digitalSignage?.publishTo[i];
          const parentDigitalSignageId = digitalSignage?.parentDigitalSignageId;

          const response = await firebase.app().functions(getRegionName()).httpsCallable('utils-getOrgDocuments')({
            orgId: this.state.authModule.currentFacilityData.orgId,
            collectionName: 'digitalSignage',
            conditions: [{property: 'parentDigitalSignageId',condition:'==',value: parentDigitalSignageId}]
          });

          const digitalSignageByFacility = response.data.data
            .filter(x => x.facilityId === facilityId);

          digitalSignageByFacility.forEach((doc) => {
            firebase.app().functions(getRegionName()).httpsCallable('utils-updateOrgDocument')({
              orgId: this.state.authModule.currentFacilityData.orgId,
              collectionName: 'digitalSignage',
              docId: doc.id,
              facilityId: facilityId,
              updates: {
                publishTo: doc?.publishTo.filter(x => x !== this.state.authModule.currentFacility),
              }
            });
          })
        }
      }
    },
    async subscribeDigitalSignage({dispatch, commit }, { id, isSetOnline }) {
      this.state.digitalSignageModule.subscribeCurrentDigitalSignage = await firebase
        .firestore()
        .collection("digitalSignage")
        .doc(id)
        .onSnapshot(async doc => {
          if(isSetOnline) {
            dispatch("setOnlineStatusToDigitalSignage", {
              id: id,
              isOnline: true
            });
          }
          dispatch("getDigitalSignage", id);
          commit("setDigitalSignageChanges");
        })
    },
    async subscribeDigitalSignageActivePage({ commit }, id: string) {
      this.state.digitalSignageModule.subscribeOnDigitalSignageActivePage = await firebase
        .firestore()
        .collection("digitalSignage")
        .doc(id)
        .collection("states")
        .doc("activePage")
        .onSnapshot(async doc => {
          commit("setDigitalSignageActivePage", doc.data().activePage);
        })
    },
    async setOnlineStatusToDigitalSignage(_, { id, isOnline }) {
      try {
        const onlineRef = firebase
          .firestore()
          .collection("digitalSignage")
          .doc(id)
          .update({
            isOnline: isOnline,
          });

        const statesRef = firebase
          .firestore()
          .collection("digitalSignage")
          .doc(id)
          .collection("states")
          .doc("activePage")
          .set(
            { activePage: isOnline ? 0 : null },
            { merge: true }
          );

        await Promise.all([onlineRef, statesRef]);
      } catch (err) {
        console.error("Error:", err);
      }
    },
    async getDigitalSignageDevices({ commit }) {
      const digitalSignageSnap = await firebase
        .firestore()
        .collection("digitalSignage")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .get();

      const devicePromises = digitalSignageSnap.docs.map(async (doc) => {
        const devicesSnap = await doc.ref.collection("devices").get();
        return devicesSnap.docs.map(device => ({
          id: device.id,
          digitalSignageId: doc.id,
          deviceNameEdited: device.data().deviceNameEdited  || device.data().deviceName,
          ...device.data()
        }));
      });

      const deviceArrays = await Promise.all(devicePromises);
      commit("setDigitalSignageDevices", deviceArrays.flat());
    },
    async initDigitalSignageTV({ dispatch, commit }, digitalSignageTV) {
      await firebase
        .firestore()
        .collection("digitalSignageTV")
        .where("brand", "==", digitalSignageTV.brand)
        .where("model", "==", digitalSignageTV.model)
        .where("osName", "==", digitalSignageTV.osName)
        .where("osVersion", "==", digitalSignageTV.osVersion)
        .where("ua", "==", digitalSignageTV.ua)
        .where("screenSize", "==", digitalSignageTV.screenSize)
        .get()
        .then(async (querySnapshot) => {
          const TV = serializer.querySnapshotToDocuments(querySnapshot)[0];

          if(TV) {
            await dispatch("updateDigitalSignageTV", {
              id: TV.id,
              updates: {
                lastActive: new Date()
              }
            })
          } else {
            await firebase
              .firestore()
              .collection("digitalSignageTV")
              .add(digitalSignageTV)
              .then(async (querySnapshot) => {
                const LoginURL = `${location.origin}/digital-signage-tv-login/${querySnapshot.id}`;

                await querySnapshot.update({
                  loginURL: LoginURL
                });

                commit("setDigitalSignageTV", {
                  ...digitalSignageTV,
                  id: querySnapshot.id,
                  loginURL: LoginURL,
                })
              });
          }
        });
    },
    async getDigitalSignageTVList({ commit }) {
      await firebase
        .firestore()
        .collection("digitalSignageTV")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("isAuth", "==", true)
        .get()
        .then((querySnapshot) => {
          let digitalSignageTVList = serializer.querySnapshotToDocuments(querySnapshot);
          digitalSignageTVList = digitalSignageTVList.map((x: any) => {
            return {
              ...x,
              assignedDateTime: moment(x.assignedDateTime.seconds * 1000).toDate(),
              lastActive: moment(x.lastActive.seconds * 1000).toDate(),
            }
          })
          commit("setDigitalSignageTVList", digitalSignageTVList);
        });
    },
    async getDigitalSignageTV({ commit }, id) {
      await firebase
        .firestore()
        .collection("digitalSignageTV")
        .doc(id)
        .get()
        .then(async (querySnapshot) => {
          commit("setDigitalSignageTV", {
            ...querySnapshot.data(),
            assignedDateTime: moment(querySnapshot.data().assignedDateTime.seconds * 1000).toDate(),
            lastActive: moment(querySnapshot.data().lastActive.seconds * 1000).toDate(),
            id: querySnapshot.id
          })
        })
    },
    async updateDigitalSignageTV({ dispatch }, data) {
      await firebase
        .firestore()
        .collection("digitalSignageTV")
        .doc(data.id)
        .update(data.updates)
        .then(async (querySnapshot) => {
          await dispatch("getDigitalSignageTV", data.id)
        })
    },
    async unAssignDigitalSignageTV({ dispatch }, id) {
      await firebase
        .firestore()
        .collection("digitalSignageTV")
        .doc(id)
        .update({
          isAuth: false,
          token: null,
          userId: null,
          userName: null,
          userStatus: null,
          updatedById: this.state.authModule.user.id,
          updatedByType: UserTypeEnum.Staff,
          typesOfRecordChanged: [`${Tier1.Settings}: ${Tier2.Kiosk}: ${Tier3.UnassignDevice}`]
        })
    },
    async subscribeOnDigitalSignageTV({ commit, dispatch }, id) {
      this.state.digitalSignageModule.subscribeOnDigitalSignageTV = await firebase
        .firestore()
        .collection("digitalSignageTV")
        .doc(id)
        .onSnapshot(async doc => {
          const token = doc.data()?.token;
          const isAuth = doc.data()?.isAuth;

          console.group("WATCH STATE")
          console.log(doc.data())
          console.groupEnd()

          if(token) {
            await dispatch("signInByCustomToken", {
              customToken: token,
              isExternalPagesViewing: true
            });

            await dispatch("updateDigitalSignageTV", {
              id: doc.id,
              updates: {
                isAuth: true,
                token: null,
                userId: this.state.authModule.user.id,
                userName: this.state.authModule.user.name ?? null,
                userStatus: this.state.authModule.user.accessLevel ?? null,
                imageUrl: this.state.authModule.user.profilePicUrl ?? null,
                facilityId: this.state.authModule.user.facilityId,
                assignedDateTime: new Date(),
                lastActive: new Date()
              }
            });

            return;
          }

          if(!token && !isAuth) {
            dispatch("getDigitalSignageTV", doc.id);
          }
        });
    }
  },
};
export default digitalSignageModule;
